export function isPurchaseAvailable(): boolean {
  const localStorageAppState = localStorage.getItem('appState') ?? ''
  const isPurchaseAvailable = JSON.parse(localStorageAppState).isPurchaseAvailable ?? false
  return isPurchaseAvailable
}

// True when this visitor buys through Stripe Managed Payments (merchant of record)
// hosted Checkout instead of the Payment Element flow. Set from getProducts by country.
export function isMorCheckoutEnabled(): boolean {
  const localStorageAppState = localStorage.getItem('appState') ?? '{}'
  return JSON.parse(localStorageAppState).morCheckoutEnabled ?? false
}

export const getSubscriptionStatus = (subscription: IStripeSubscription): ISubscriptionStatus => {
  if (subscription.status === 'canceled') {
    return 'expired'
  } else if (subscription.pause_collection != null) {
    return 'onHold'
  } else if (subscription.canceled_at == null) {
    return 'active'
  } else if (subscription.canceled_at != null) {
    return 'canceled'
  } else {
    throw Error('Unknown subscription status')
  }
}

export const SPECIAL_OFFER_GROUP_ID: SubscriptionGroupId = 'v13'
